import * as Sentry from '@sentry/browser'

const config = window.__SENTRY_CONFIG__ || {}

if (config.dsn) {
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment || 'unknown',
    release: config.release || undefined,
  })
}

window.Sentry = Sentry
